module.exports = __webpack_public_path__ + "static/media/pg30.c826047a.jpg";